import { css } from '@linaria/core';

export const Root = {
	base: css`
		margin-bottom: 50px;
	`,
};
